var _g, _path, _rect, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 8.06636C3 6.9908 3.43315 5.96055 4.20171 5.20811L7.33378 2.14175C8.08135 1.40987 9.08589 1 10.1321 1H21C23.2091 1 25 2.79086 25 5V25C25 27.2091 23.2091 29 21 29H7C4.79086 29 3 27.2091 3 25V8.06636Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 8.06636C3 6.9908 3.43315 5.96055 4.20171 5.20811L7.33378 2.14175C8.08135 1.40987 9.08589 1 10.1321 1H21C23.2091 1 25 2.79086 25 5V25C25 27.2091 23.2091 29 21 29H7C4.79086 29 3 27.2091 3 25V8.06636Z",
    stroke: "#828896"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1V4C9 5.65685 7.65685 7 6 7H3",
    stroke: "#828896",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 19,
    height: 10,
    rx: 2,
    fill: "#19B0F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0826 18.5V13.4091H13.0911C13.4773 13.4091 13.8062 13.4828 14.078 13.6303C14.3498 13.7762 14.5569 13.9792 14.6994 14.2393C14.8436 14.4979 14.9157 14.7962 14.9157 15.1342C14.9157 15.4723 14.8428 15.7706 14.697 16.0291C14.5511 16.2876 14.3398 16.489 14.0631 16.6332C13.788 16.7773 13.4549 16.8494 13.0638 16.8494H11.7836V15.9869H12.8898C13.0969 15.9869 13.2676 15.9512 13.4019 15.88C13.5377 15.8071 13.6388 15.7068 13.7051 15.5792C13.7731 15.4499 13.807 15.3016 13.807 15.1342C13.807 14.9652 13.7731 14.8177 13.7051 14.6918C13.6388 14.5642 13.5377 14.4656 13.4019 14.396C13.266 14.3247 13.0936 14.2891 12.8848 14.2891H12.159V18.5H11.0826ZM17.4195 18.5H15.6148V13.4091H17.4344C17.9465 13.4091 18.3873 13.511 18.7569 13.7148C19.1264 13.917 19.4106 14.2079 19.6095 14.5874C19.81 14.9669 19.9103 15.4209 19.9103 15.9496C19.9103 16.4799 19.81 16.9356 19.6095 17.3168C19.4106 17.6979 19.1248 17.9904 18.7519 18.1942C18.3807 18.3981 17.9366 18.5 17.4195 18.5ZM16.6912 17.5778H17.3748C17.693 17.5778 17.9606 17.5214 18.1777 17.4087C18.3964 17.2944 18.5605 17.1179 18.6699 16.8793C18.7809 16.639 18.8364 16.3291 18.8364 15.9496C18.8364 15.5734 18.7809 15.266 18.6699 15.0273C18.5605 14.7887 18.3973 14.613 18.1802 14.5004C17.9631 14.3877 17.6954 14.3313 17.3773 14.3313H16.6912V17.5778ZM20.7076 18.5V13.4091H24.0783V14.2965H21.784V15.5096H23.8546V16.397H21.784V18.5H20.7076Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_19",
    x: -22.5,
    y: -14.5,
    width: 73,
    height: 79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1_19"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_19"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_19",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.da3546bfdadf6e7abeeb5e5400f9fb08.svg";
export { ForwardRef as ReactComponent };